import type { AuthenticationSession } from "./AuthenticationSession";

let installedSession: AuthenticationSession | null = null;

export function installAuthenticationSession(session: AuthenticationSession): void {
  if (installedSession) {
    throw new Error("Authentication session is already installed");
  }
  installedSession = session;
}

export function getAuthenticationSession(): AuthenticationSession {
  if (!installedSession) {
    throw new Error("Authentication session is not installed; bootstrap must complete first");
  }
  return installedSession;
}